import { reduce, has, hasPath } from 'ramda'

// todo: return list of error messages instead of doing console.error
export const validateProps = props => propObject =>
  reduce(
    (a, n) => {
      const hasIt = has(n, propObject)
      if (!hasIt) console.error(`prop is missing field "${n}"`)
      return a && hasIt
    },
    true,
    props,
  )

export const validatePaths = paths => propObject =>
  reduce(
    (a, n) => {
      const hasIt = hasPath(n, propObject)
      if (!hasIt) console.error(`prop is missing path "${n.join('.')}"`)
      return a && hasIt
    },
    true,
    paths,
  )
